// Security string helpers — ported from legacy v20_Index.html (lines ~1031-1044).
// These are the ONLY sanctioned ways to move user-sourced strings into HTML,
// attribute/JS-string contexts, or CSV cells.

/**
 * HTML-escape any user-sourced string before it goes into innerHTML.
 * Patient names, notes etc. arrive from the PUBLIC consent form — without this,
 * a submission named `<img src=x onerror=…>` executes in a nurse's session.
 * Exact port of legacy esc(): & first, then < > " '.
 * @param {unknown} s
 * @returns {string}
 */
export function esc(s) {
  return String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * Make a value safe to embed inside a '…' string in generated JS or an
 * attribute. Strips every character that could break out of the JS string or
 * the surrounding attribute.
 *
 * Ported from legacy jsq() WITH the `&` fix: the legacy strip set
 * [\\ ' " < > U+2028 U+2029] left `&` intact, so a value like `&#39;` survived
 * into an esc()-escaped attribute where the browser decodes `&#39;` back to a
 * real quote — re-opening the very breakout esc() closed. `&` is now stripped
 * too. (U+2028/U+2029 are the JS line separators — also stripped, as in legacy.)
 * @param {unknown} s
 * @returns {string}
 */
export function jsq(s) {
  return String(s ?? '').replace(/[\\'"<>&\u2028\u2029]/g, '');
}

/**
 * Neutralise spreadsheet formula injection. A cell value beginning with
 * = + - @ (or a leading tab/CR) is treated by Excel/Sheets as a formula —
 * and patient names come from the PUBLIC consent form. Prefix such values
 * with a single quote so they render as literal text. Returns a plain string
 * for the caller to apply its own CSV quoting/escaping to. Exact legacy port.
 * @param {unknown} v
 * @returns {string}
 */
export function csvSafe(v) {
  const s = String(v ?? '');
  return /^[=+\-@\t\r]/.test(s) ? "'" + s : s;
}
